import React, { Component } from 'react';
import AutoForm from '../../components/Form';
import SChangePassword from 'shared/screens/Settings/ChangePassword';
import ImageBW from '../../components/ImageBoundsWrapper';
import { getText, TEXT_KEY } from 'shared/utils/localization';

export default class ChangePassword extends Component {
  render() {
    const activeBG = require(asset`RoundedRect_Pink@2x.png`);
    return (
      <SChangePassword
        {...this.props}
        navigation={this.props.navigation}
        render={args => {
          const { layout, messageResponse, responseSuccess, changePassword } = args;

          const { goBackHandler, onShowPopUp, showPopUp, screensEnum } = this.props;

          const showPopUpHandler = success => {
            onShowPopUp(success ? screensEnum.changePasswordSuccess : screensEnum.changePasswordError);
          };

          return (
            <>
              {!showPopUp ? (
                <AutoForm
                  layout={layout}
                  prev={goBackHandler}
                  next={() => {
                    changePassword(showPopUpHandler);
                  }}
                  serverResponse={messageResponse}
                  customStyle={{
                    position: 'absolute',
                    bottom: '0.8rem',
                    left: '1rem',
                    right: '1rem',
                  }}
                  formCustomContent
                  customConfirmButton
                  hideTopBar
                />
              ) : (
                <div className="popup-content-container">
                  <div />
                  <p className="popup-message-text">
                    {responseSuccess ? getText(TEXT_KEY.SUCCESS_RESPONSE) : getText(TEXT_KEY.SOMETHING_WENT_WRONG)}
                    <br />
                    {messageResponse}
                  </p>
                  <div className="done-button-container" onClick={goBackHandler}>
                    <ImageBW
                      source={activeBG}
                      ibw={require(asset`Confirm_Button.ibw`)}
                      style={{ objectFit: 'contain' }}
                      className="continue-button-background-image"
                      innerStyle={{
                        cursor: 'pointer',
                      }}
                    >
                      <div className="done-button-content">
                        <span className="done-button-text" data-label="CONTINUE">
                          {getText(TEXT_KEY.CONTINUE_BUTTON)}
                        </span>
                      </div>
                    </ImageBW>
                  </div>
                </div>
              )}
            </>
          );
        }}
      />
    );
  }
}
